import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useHasGroup } from '../../hooks/useHasGroup';

/**
 * Renders the `contingent_exceeded` error details and offers staff users
 * an "Override" button that re-calls the supplied submit handler with
 * `override_contingent: true`.
 *
 * `error` is the normalized ApiError (from getApiError); show is derived
 * from its presence. Pass `onClose` to dismiss and `onOverride` to retry.
 */
const ContingentExceededModal = ({ error, onClose, onOverride }) => {
  // useHasGroup already grants superusers; 'contingents' members may override.
  const canOverride = useHasGroup('contingents');

  if (!error || error.code !== 'contingent_exceeded') return null;

  const lines = error.details?.violations || [];
  const hint = error.details?.hint;

  return (
    <Modal show={true} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Kontingent überschritten</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Folgende Positionen überschreiten das hinterlegte Kontingent:</p>
        <ul>
          {lines.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
        {hint && canOverride && <p className='text-muted small'>{hint}</p>}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Abbrechen
        </Button>
        {canOverride && onOverride && (
          <Button variant='warning' onClick={onOverride}>
            Trotzdem anlegen (Override)
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ContingentExceededModal;
